import { Badge } from '@/components/ui/badge';
import { LucideIcon } from 'lucide-react';

interface IntakeAssetCardProps {
  title: string;
  icon: LucideIcon;
  present: boolean;
  children?: React.ReactNode;
}

export function IntakeAssetCard({ title, icon: Icon, present, children }: IntakeAssetCardProps) {
  return (
    <div className="rounded-lg border p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Icon className="h-5 w-5 text-muted-foreground" />
          <span className="font-medium">{title}</span>
        </div>
        <Badge variant={present ? 'default' : 'secondary'}>
          {present ? 'Aanwezig' : 'Niet aanwezig'}
        </Badge>
      </div>
      {present && children && (
        <div className="text-sm text-muted-foreground space-y-1">
          {children}
        </div>
      )}
    </div>
  );
}
